import useUserPermissions from "../../../../../common/utils/user/permissions/use-user-permissions";
import routeFinishedListingUserPermissionDefinition from "./route-finished-listing-user-permission";

const useRouteFinishedListingUserPermissions = () => {
  return useUserPermissions(routeFinishedListingUserPermissionDefinition);
};

export default useRouteFinishedListingUserPermissions;
